import Vapi from "vuex-rest-api"
import User from '@/models/User';
import AppEvents from '@/AppEvents';
import Destination from "@/components/Passenger/models/Destination";
import DestinationRole, { PermissionEnum } from "@/models/DestinationRole";

const userApi = new Vapi({
        baseURL: process.env.VUE_APP_API_HOST + "/api/user",
        state: {
            me: null,
            showWeekends: false,
            weekStartsOnSunday: false
        }
    })
    .get({
        action: "getMe",
        property: "me",
        path: "/me",
        onSuccess: (state, payload, axios) => {
          state.me = User.fromApi(payload.data);
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .post({
      action: "sendRecoveryEmail",
      property: "forgotPassword",
      path: "/forgotPassword",
      onSuccess: (state, payload, axios) => {
          // console.log("sendRecoveryEmail onSuccess", state, payload.data);
          return;
      },
      onError: (state: any, error: any, axios: any) => {
          AppEvents.handleApiError(error);
      }
    })
    .post({
      action: "validateResetPasswordCode",
      property: "validateResetPasswordCode",
      path: "/validateResetPasswordCode",
      onSuccess: (state, payload, axios) => {
          // console.log("validateResetPasswordCode onSuccess", state, payload.data);
          return;
      },
      onError: (state: any, error: any, axios: any) => {
          AppEvents.handleApiError(error);
      }
    })
    .post({
      action: "resetPassword",
      property: "resetPassword",
      path: "/resetPassword",
      onSuccess: (state, payload, axios) => {
          // console.log("resetPassword onSuccess", state, payload.data);
          return;
      },
      onError: (state: any, error: any, axios: any) => {
          AppEvents.handleApiError(error);
      }
    })
    .post({
      action: "sendSupportRequest",
      property: "supportRequest",
      path: "/supportRequest",
      onSuccess: (state, payload, axios) => {
          // console.log("sendSupportRequest onSuccess", state, payload.data);
          return;
      },
      onError: (state: any, error: any, axios: any) => {
          AppEvents.handleApiError(error);
      }
    })

const userStore = userApi.getStore();
(userStore as any).namespaced = true;
(userStore as any).persist = ["showWeekends", "weekStartsOnSunday"];

// showWeekends: Whether to show weekends in calendar and timetable
(userStore.state as any).showWeekends = false;

userStore.mutations.addDestinationPermission = (state, value: Destination) => {

  const newRole = DestinationRole.newAdminRole(value.id);
  (state.me as User).destinationRoles.push(newRole)
}

userStore.mutations.setShowWeekends = (state, value) => {
  state.showWeekends = value;
}
userStore.actions.setShowWeekends = (context, value) => {
  context.commit("setShowWeekends", value)
}

// weekStartsOnSunday: true if week starts on Sunday, false if on Monday 
(userStore.state as any).weekStartsOnSunday = false;
userStore.mutations.setWeekStartsOnSunday = (state, value) => {
  state.weekStartsOnSunday = value;
}
userStore.actions.setWeekStartsOnSunday = (context, value) => {
  context.commit("setWeekStartsOnSunday", value)
}

export default userStore;
